// extracted by mini-css-extract-plugin
export default {"track":"pill-toggle_track__KYlmp","slider":"pill-toggle_slider__1F2dX","btn":"pill-toggle_btn__X-fin","active":"pill-toggle_active__g57Cq"};